import React, { useState, useEffect, useRef } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { getGradeOptions, redirectToPages, resultAlert } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/grade-courses/GradeCoursesAction";
import { 
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { GradeCourseEditForm } from "./GradeCourseEditForm";

export function GradeCourseEdit({
  history,
  match: {
    params: { id }
  }
}) {
  const [title, setTitle] = useState("");
  const [gradeOptions, setGradeOptions] = useState([]);
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, gradeCourse } = useSelector(
    (state) => ({
      actionsLoading: state.gradeCourses.actionsLoading,
      isSuccess: state.gradeCourses.isSuccess,
      type: state.gradeCourses.type,
      gradeCourse: state.gradeCourses.gradeCourse
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCourse(id));
    return () => dispatch(actions.cleanCoursesState());
  }, [id, dispatch]);
  
  useEffect(() => {
    let _title = "Ders";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (gradeCourse.gradeLevel) setGradeOptions(getGradeOptions(gradeCourse.gradeLevel));
  }, [gradeCourse]);
  
  /** Belli Bir Sınıf Dersini Kaydeder */
  const saveCourse = (values) => {
    dispatch(actions.saveCourse(values)).then((result) => onResult(result));
  };
  
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => history.push(`/sinif-dersleri`), 2500);
  };

  const btnRef = useRef();  
  const saveCourseClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title} />
      <CardBody>
        <div className="mt-5">          
          <GradeCourseEditForm
            gradeOptions={gradeOptions}
            gradeCourse={gradeCourse}
            btnRef={btnRef} 
            setGradeOptions={setGradeOptions}
            saveCourse={saveCourse}
          />
        </div>
      </CardBody>
      <CardFooter>
        <div className="offset-sm-2">          
          <button
            type="submit"
            className="btn btn-primary"
            onClick={saveCourseClick}
          >
            Kaydet
          </button>          
        </div>
      </CardFooter>
    </Card>
  );
}